import React from 'react'

import { PercentWrap } from './styled'

const getMatchPercentText = (matchPercent: number | null) => {
  if (matchPercent === null) return '-'
  if (matchPercent === -1) return 'calculating'
  return `${String(matchPercent)}%`
}

interface Props {
  matchPercent: number | null
}
export const MatchPercentValue: React.FC<Props> = ({ matchPercent }) => {
  return <PercentWrap>{getMatchPercentText(matchPercent)}</PercentWrap>
}
